import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import EditWP_Detail from './EditWP-Detail'
import Historylog from './Historylog'
import del from '../../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
//mport PropTypes from 'prop-types';
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { wplookupdescription, geteditwpdocinfo, filedeletewp } from "../../../../actions/WPAction";
import moment from "moment"
import $ from "jquery";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { putwpdocinfo, deletemulitiwpdocs } from "../../../../actions/WPAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import { FOCUSABLE_SELECTOR } from "@testing-library/user-event/dist/utils";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

class EditWP extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            Docs: [],
            DeleteData: [],
            others: false,
            cancel: false,
            isMobile: false,
            isError: false,
            Error: {
                "DescriptionError": false,
                "PermitDateError": false,
                "PermitTypeError": false,
            },
            value: 0,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Description": "",
                "PermitDate": "",
                "PermitType": "",
                "Comments": "",
                "Modifiedby": ''
            }
        }
    }
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("WPEditId"))
        let tempdata = {
            data: parseInt(localStorage.getItem("WPEditId"))
        }
        this.state.DeleteData.push(tempdata)
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.geteditwpdocinfo(this.state.addData.Id)
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.props.dispatch({ type: "ERROR_WPFILES", data: this.state.Error })
        window.location.pathname == '/workpermits/edit' ? this.setState({ isView: false }) : this.setState({ isView: false })
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#WORK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Workpermits1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Workpermits").addClass("d-none");
        $("#Workpermits").removeClass("d-block");
        $("#WPL").removeClass("active-color");
        $("#WPT").removeClass("fw-bolder");
    }
    geteditwpdocinfo = (id) => {
        let apiUrl = API.WP_LISTVIEW + '/' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Description = response.data.Description;
                    this.state.addData.PermitDate = response.data?.PermitDate;
                    this.state.addData.PermitType = response.data?.PermitType;
                    this.state.addData.Comments = response.data?.Comments;
                    if (response.data?.Atttachments.length > 0) {
                        response.data?.Atttachments.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.Docs = response.data?.Atttachments;
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })

                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (this.state.value == 1) {
            // this.geteditwpdocinfo(this.state.addData.Id)
        }
    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleProjectNameSearchChange = (e) => {
        this.state.addData.Description = e.target.value;
        this.setState({});
    };

    handleProjectNameSelectChange = (e) => {
        this.state.addData.Description = e;
        this.setState({});
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        if (window.innerWidth < 412) {
            this.setState({
                isMore: true
            })
        }
        else {
            this.setState({
                isMore: false
            })
        }
        $("#WORK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Workpermits1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Workpermits").removeClass("d-none");
        $("#Workpermits").addClass("d-block");
        $("#WPL").addClass("active-color");
        $("#WPT").addClass("fw-bolder");
    };

    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (str == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else if (str == "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[str] = e.target.value;
            this.setState({});
        }
        this.setState({})

    };

    AddCancel1 = () => {
        if (this.state.value == 1) {
            this.state.value = 0
            this.setState({})
            this.geteditwpdocinfo(this.state.addData.Id)
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show");
            } else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate(`/workpermits`)
            }
        }
    }

    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/workpermits")
    };

    EditSave = () => {
        if (this.state.addData.Description.trim() == "") {
            this.state.Error.DescriptionError = true;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        else {
            this.state.Error.DescriptionError = false;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        if (this.state.addData.PermitDate == "") {
            this.state.Error.PermitDateError = true;
            this.setState({})
        }
        else {
            this.state.Error.PermitDateError = false;
            this.setState({})
        }
        if (this.state.addData.PermitType == "") {
            this.state.Error.PermitTypeError = true;
            this.setState({})
        }
        else {
            this.state.Error.PermitTypeError = false;
            this.setState({})
        }
        if (this.state.addData.Description !== '' && this.state.addData.PermitDate !== '' && this.state.addData.PermitType !== '') {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData();
            let array = [];
            Array.from(this.state.Docs).forEach(async (a) => {
                if (a.AwsUniqueFileName == undefined) {
                    formData.append("attachments", a.fdata)
                    array.push(a)
                }
            })
            if (this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
                this.setState({})
            }
            this.putwpdocinfo(this.state.addData, formData, this.state.addData.Id, array)
        }
        else {
        }
    }

    putwpdocinfo = (data, formData, id, array) => {
        let apiUrl = API.WP_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (array.length > 0) {
                        this.adduploadwpdocinfo(formData, id)
                    }
                    else {
                        this.props.navigate("/workpermits")
                    }
                }
                else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    adduploadwpdocinfo = (data, id) => {
        let apiUrl = API.WP_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/workpermits")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            this.state.Docs.push(upload)
            this.setState({})
        })
    };
    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }
    DeleteItem1 = () => {
        let tempData = [];
        this.state.Docs.map((i) => {
            if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeletewp(this.state.addData.Id, this.state.awsname, this.state.addData.Modifiedby))
            }
            if (i.FileName != this.state.filename) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopup1").modal("hide");
    }
    DeleteItem = () => {
        this.deletemulitiwpdocs(this.state.DeleteData, this.state.ProjectId, this.state.addData.Modifiedby)
    }

    deletemulitiwpdocs = (data, id, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val.data;
                }
                else {
                    ids += "&ids=" + val.data;
                }
            })
        }
        let apiUrl = API.WP_LISTVIEW + '/ids?' + ids + '&modify=' + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
            // data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/workpermits")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-4 w-50 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"WORK" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="WORK" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-8 pt-2 mt-5 w-50 ">
                                    <h4>Edit Work Permits</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <>

                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td className={this.state.value == 0 ? "border-right text-center" : ""}>
                                        {this.state.value == 0 ?
                                            <span className={`${classes.button}`} style={{ minWidth: '60px' }} onClick={this.EditSave} ><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span> : <></>}
                                    </td>
                                    <td className={this.state.value == 0 ? "border-right text-center" : ""}>
                                        {this.state.value == 0 ?
                                            <span className={`${classes.button}`} style={{ minWidth: '70px' }} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span> : <></>}
                                    </td>
                                    <td className={this.state.value == 0 ? "border-right text-center" : ""}>
                                        {this.state.value == 0 ?
                                            <span className={`${classes.button} `} style={{ minWidth: '70px' }} data-target="#deletepopup01" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span> : <></>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        {this.state.value == 1 ? <></> : <>
                                            {this.state.isView ? <></> :
                                                <button className={`${classes.button} pl-3`} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>}
                                            <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>

                                            {this.state.DeleteisView ? <></> :
                                                <button className={`${classes.button}`} data-target="#deletepopup01" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>}</>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">Edit Work Permits</h6>}
                        <div className="row">
                            <div >
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" className=" px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                        <Tab label="History log" className="" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? "row px-0 mt-n3" : "row px-2 mt-n3"}>
                                            <div className={`row  mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 float-end text-right d-flex "}>Description&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    {this.state.Error.DescriptionError ?
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            multiline
                                                            value={this.state.addData.Description}
                                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                                            rows={4}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        /> : <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            multiline
                                                            value={this.state.addData.Description}
                                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                                            rows={4}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                    }
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "px-0 mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right d-flex"}>Permit Date&nbsp;:
                                                        <div className={`${classes.MuiFormHelperTextcontained}`}>
                                                            *
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-lg-10 col-md-10 pt-4 pb-4"}`}>
                                                    {this.state.Error.PermitDateError ?
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            id="type-date"
                                                            value={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleInputChange(e, "PermitDate") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                            inputProps={{
                                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                              }}
                                                        />
                                                        :
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            id="type-date"
                                                            value={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleInputChange(e, "PermitDate") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                            inputProps={{
                                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                              }}
                                                        />
                                                    }
                                                </div>
                                                <div className={`col-12 col-sm-12 col-lg-2  col-xl-1  ${this.state.isMobile ? "border-left border-right" : "px-0 mt-2 col-lg-2  col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right d-flex"}>Permit Type&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div>

                                                    </label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-xl-7  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 col-lg-12 pt-1 pb-3" : "col-lg-10 col-md-10 pt-4 pb-4"}`}>
                                                    {this.state.Error.PermitTypeError ?
                                                        <>
                                                            <RadioGroup row value={this.state.addData.PermitType} onChange={(e) => { this.handleInputChange(e, "PermitType") }} fullWidth>
                                                                <FormControlLabel value="Hot Work Permit" control={<Radio color="default" className={classes.error} />} label="Hot Work Permit" size="small" />
                                                                <FormControlLabel value="Cold Work Permit" control={<Radio color="default" className={classes.error} />} label="Cold Work Permit" size="small" />
                                                            </RadioGroup>
                                                        </>
                                                        :
                                                        <RadioGroup row value={this.state.addData.PermitType} onChange={(e) => { this.handleInputChange(e, "PermitType") }} fullWidth>
                                                            <FormControlLabel value="Hot Work Permit" control={<Radio color="default" />} label="Hot Work Permit" size="small" />
                                                            <FormControlLabel value="Cold Work Permit" control={<Radio color="default" />} label="Cold Work Permit" size="small" />
                                                        </RadioGroup>}
                                                </div>
                                            </div>
                                            <div className={`row mx-0 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? " mt-2" : "float-end pt-4 text-right"}>Attachments&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        disabled
                                                        onChange={(e) => { this.UploadFile(e) }}
                                                        placeholder="Browse File"
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment className="mr-0">
                                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                        <AttachFileIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }} />
                                                    <input
                                                        type="file"
                                                        hidden
                                                        multiple="multiple"
                                                        onChange={(e) => { this.UploadFile(e) }}
                                                        ref={this.inputFile}
                                                    />
                                                </div>

                                                <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                    <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                        {this.state.Docs && this.state.Docs.map((i, ind) => {
                                                            return (
                                                                <div className={`col-6 col-lg-4 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 360 ? "col-12" : this.state.isMobile ? "col-md-4 col-sm-4" : "col-md-6 col-sm-6"}`}>
                                                                    <div className="row d-flex pr-3">
                                                                        <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                                            <div className="pt-2 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                        </div>
                                                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pl-1 pr-2 mt-2 pt-1">
                                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id) }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "mt-2" : "float-end"}>Comments&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    <TextField
                                                        multiline
                                                        rows={8}
                                                        variant="outlined"
                                                        size="small"
                                                        value={this.state.addData.Comments}
                                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                                        fullWidth
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <Historylog />
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup01" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem1}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        sharedwpfile: state.WPReducer.sharedwpfile || [],
        sharedwpdata: state.WPReducer.sharedwpdata || [],
        WPDESC_LOOKUP: state.WPReducer.WPDESC_LOOKUP || [],
        settings: state.commonReducer.settings || [],
    };
}

EditWP.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditWP))
);
